module.exports = __webpack_public_path__ + "img/blob-top-min.3a5c5dfb.png";